<template>
  <v-card v-if="vehicle">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Configuration") }}</h3>
    </v-btn>
    <v-btn
      color="blue"
      x-small
      class="tariff-right-headers"
      style="float: right"
      @click="vehicle.blockedFor.push({ by: 'Me' })"
      >{{ $i18n.t("Add") }}</v-btn
    >
    <v-row style="padding: 10px 10px">
      <v-simple-table style="width: 100%; margin: 10px">
        <thead>
          <tr>
            <th class="primary--text">{{ $i18n.t("#") }}</th>
            <th class="primary--text">{{ $i18n.t("Client") }}</th>
            <th class="primary--text">{{ $i18n.t("By") }}</th>
            <th class="primary--text">{{ $i18n.t("Time") }}</th>
            <th class="primary--text">{{ $i18n.t("Reason") }}</th>
            <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(blockedFor, index) in vehicle.blockedFor" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <z-client-select
                :disabled="blockedFor.at != null && blockedFor.at != undefined"
                v-model="blockedFor.client_id"
                label
              ></z-client-select>
            </td>
            <td>{{ blockedFor.by }}</td>
            <td>{{ blockedFor.at | moment("HH:mm DD MMM YYYY") }}</td>
            <td>
              <v-text-field v-model="blockedFor.reason"></v-text-field>
            </td>
            <td>
              <v-btn
                color="red"
                small
                text
                fab
                @click="remove(vehicle.blockedFor, index)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
// import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Config",
  props: {
    value: {
      default: null,
    },
  },
})
export default class Config extends Vue {
  vehicle = null;

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onValueChange(newVal) {
    this.vehicle = newVal;
  }

  async mounted() {
    if (this.value) this.vehicle = this.value;

    if (!this.vehicle) this.vehicle = {};
    if (!this.vehicle.vehicleDetail) this.vehicle.vehicleDetail = {};
    if (!this.vehicle.vehicleDetail.fitness)
      this.vehicle.vehicleDetail.fitness = {};
  }

  addExpenseUrl() {
    return;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>